import { User, UserHelper } from './user';

export interface UserGeneric {
    invoice_name: string;
    invoice_lastname: string;
    invoice_address: string;
    invoice_email: string;
    invoice_province: string;
    invoice_city: string;
    invoice_zip_code: string;
    invoice_phone: string;
    invoice_cif: string;

    same_address_shipping: boolean;

    shipping_name: string;
    shipping_lastname: string;
    shipping_address: string;
    shipping_email: string;
    shipping_province: string;
    shipping_city: string;
    shipping_zip_code: string;
    shipping_phone: string;
    shipping_cif: string;
}

export class UserGenericHelper {
    static create(): UserGeneric {
        return {
            invoice_name: '',
            invoice_lastname: '',
            invoice_address: '',
            invoice_email: '',
            invoice_province: '',
            invoice_city: '',
            invoice_zip_code: '',
            invoice_phone: '',
            invoice_cif: '',
            same_address_shipping: true,
            shipping_name: '',
            shipping_lastname: '',
            shipping_address: '',
            shipping_email: '',
            shipping_province: '',
            shipping_city: '',
            shipping_zip_code: '',
            shipping_phone: '',
            shipping_cif: '',
        };
    }

    /**
     * Create a UserGeneric from User
     *
     * @static
     * @param {User} user
     * @returns {UserGeneric}
     *
     * @memberOf UserGeneric
     */
    static fromUser(user: User): UserGeneric {

        // Create object
        const obj = UserGenericHelper.create();
        const selectedAddress = UserHelper.getSelectedAddress(user);
        obj.invoice_name = user.clienteNombre;
        obj.invoice_address = selectedAddress.direccion;
        obj.invoice_province = selectedAddress.provincia;
        obj.invoice_city = selectedAddress.municipio;
        obj.invoice_zip_code = '' + selectedAddress.cp;
        obj.invoice_phone = user.clienteTelefono;
        obj.invoice_cif = user.clienteNif;

        // Rpad zip code
        while (obj.invoice_zip_code.length < 5) {
            obj.invoice_zip_code = '0' + obj.invoice_zip_code;
        }


        // If we have different delivery address
        if (
            user.shipping_name !== '' && 
            user.shipping_lastname !== '' &&
            user.shipping_address !== '' &&
            user.shipping_city !== '' &&
            user.shipping_zip_code !== '' &&
            user.shipping_phone !== ''
        ) {
            obj.shipping_name = user.shipping_name;
            obj.shipping_lastname = user.shipping_lastname;
            obj.shipping_address = user.shipping_address;
            obj.shipping_city = user.shipping_city;
            obj.shipping_zip_code = user.shipping_zip_code;
            obj.shipping_phone = user.shipping_phone;
        } else {
            obj.same_address_shipping = false;
        }
        

        return obj;
    }
}
